// extracted by mini-css-extract-plugin
export var menuIcon = "_oc-0";
export var menuIconInline = "_oc-1";